// extracted by mini-css-extract-plugin
export default {"gradient-bg5":"savedListItem__gradient-bg5__UGUgV","container":"savedListItem__container__VfOh1","name":"savedListItem__name__ZQtJD","remove":"savedListItem__remove__kQQ2J"};